<form
  [formGroup]="workExperienceForm"
  class="max-w-5xl space-y-4"
  (ngSubmit)="saveWorkExperience()">

  <div
    formArrayName="experiences"
    class="space-y-4">

    @for (
      experience of experiences.controls;
      track experience;
      let i = $index
    ) {

      <details
        [open]="openExperienceIndex === i"
        class="group border-b pb-4"
        [formGroupName]="i">

        <summary
          class="cursor-pointer list-none flex items-center justify-between text-sm font-semibold text-slate-700"
          (click)="toggleExperience(i, $event)">

          <div class="flex items-center gap-2">
            <span class="inline-block w-4 text-center group-open:rotate-90 transition-transform">
              &#9656;
            </span>

            Experience {{ i + 1 }}
          </div>

          <button
            type="button"
            class="text-xs font-semibold text-sky-700 hover:underline"
            (click)="addExperience($event)">

            Add More

          </button>

        </summary>

        <div class="relative mt-3 bg-zinc-100 border rounded-md p-6 space-y-4">

          @if (i > 0) {

            <button
              type="button"
              class="btn btn-circle btn-outline btn-sm absolute right-1 top-1"
              aria-label="Remove work experience"
              (click)="removeExperience(i, $event)">

              x

            </button>

          }

          <!-- Institute -->

          <div class="grid grid-cols-[180px_1fr] items-center gap-4">

            <label class="text-sm font-medium text-slate-700">
              Institute
              <span class="text-red-600">*</span>
            </label>

            <div class="w-full">

              <input
                type="text"
                class="input input-bordered w-full"
                [ngClass]="{ 'error': showError(experience.get('institute')) }"
                formControlName="institute">

              @if (showError(experience.get('institute'))) {

                <p class="mt-1 text-xs text-red-600">
                  {{ getTextError(experience.get('institute'), 'Institute') }}
                </p>

              }

            </div>

          </div>

          <!-- Designation -->

          <div class="grid grid-cols-[180px_1fr] items-center gap-4">

            <label class="text-sm font-medium text-slate-700">
              Designation
              <span class="text-red-600">*</span>
            </label>

            <div class="w-full">

              <input
                type="text"
                class="input input-bordered w-full"
                [ngClass]="{ 'error': showError(experience.get('position')) }"
                formControlName="position">

              @if (showError(experience.get('position'))) {

                <p class="mt-1 text-xs text-red-600">
                  {{ getTextError(experience.get('position'), 'Designation') }}
                </p>

              }

            </div>

          </div>

          <!-- From Date -->

          <div class="grid grid-cols-[180px_1fr] items-center gap-4">

            <label class="text-sm font-medium text-slate-700">
              From
              <span class="text-red-600">*</span>
            </label>

            <div class="w-full">

              <input
                type="date"
                class="input input-bordered w-full"
                formControlName="fromdate"
                [max]="todayDate"
                [ngClass]="{ 'error': showError(experience.get('fromdate')) || showDateRangeError(experience) }"
                (change)="calculateDuration(i)">

              @if (showError(experience.get('fromdate'))) {

                <p class="mt-1 text-xs text-red-600">
                  {{ getDateError(experience.get('fromdate'), 'From date') }}
                </p>

              }

            </div>

          </div>

          <!-- To Date -->

          <div class="grid grid-cols-[180px_1fr] items-center gap-4">

            <label class="text-sm font-medium text-slate-700">
              To
              <span class="text-red-600">*</span>
            </label>

            <div class="w-full">

              <input
                type="date"
                class="input input-bordered w-full"
                formControlName="todate"
                [min]="experience.get('fromdate')?.value"
                [max]="todayDate"
                [ngClass]="{ 'error': showError(experience.get('todate')) || showDateRangeError(experience) }"
                (change)="calculateDuration(i)">

              @if (showError(experience.get('todate'))) {

                <p class="mt-1 text-xs text-red-600">
                  {{ getDateError(experience.get('todate'), 'To date') }}
                </p>

              }

              @if (showDateRangeError(experience)) {

                <p class="mt-1 text-xs text-red-600">
                  To date must be after or same as From date
                </p>

              }

            </div>

          </div>

          <!-- Duration -->

          <div class="grid grid-cols-[180px_1fr] items-center gap-4">

            <label class="text-sm font-medium text-slate-700">
              Duration
            </label>

            <div class="flex items-center gap-3">

              <input
                type="text"
                class="input input-bordered w-full"
                formControlName="duration"
                readonly>

              

            </div>

          </div>

          <!-- Description -->

          <div class="grid grid-cols-[180px_1fr] items-start gap-4">

            <label class="text-sm font-medium text-slate-700 pt-2">
              Description
            </label>

            <div class="w-full">
              <textarea
                class="textarea textarea-bordered w-full"
                rows="3"
                [ngClass]="{ 'error': showError(experience.get('description')) }"
                formControlName="description"></textarea>

              @if (showError(experience.get('description'))) {

                <p class="mt-1 text-xs text-red-600">
                  {{ getTextError(experience.get('description'), 'Description') }}
                </p>

              }
            </div>

          </div>

        </div>

      </details>

    }

  </div>

  <div class="flex justify-end">

    <button
      type="submit"
      class="btn btn-primary"
      [disabled]="isSaving">

      {{ isSaving ? 'Saving...' : 'Save' }}

    </button>

  </div>

</form>
